import { render } from "./HomeLabImage.vue?vue&type=template&id=2d78e53f&scoped=true&ts=true"
import script from "./HomeLabImage.vue?vue&type=script&lang=ts"
export * from "./HomeLabImage.vue?vue&type=script&lang=ts"

import "./HomeLabImage.vue?vue&type=style&index=0&id=2d78e53f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d78e53f"]])

export default __exports__